import React from 'react';
import '../../bootstrap.min.css';
import './header.css';
import logo from '../../common/logo.svg'
import { useAuth } from "react-oidc-context";
// @ts-ignore
import {UserManager, UserManagerSettings, WebStorageStateStore} from "oidc-client-ts";
import {Link, useLocation,useNavigate} from "react-router-dom";
import useFilterDataStore from "../../store/advanceFilterStore";
import headerBackgroundImage from "../../common/head-bg.png";
import useUserStore from "../../store/userStore";
import UserMenu from "../userMenu/userMenu";
import {LOGIN_URL} from "../../utilities/API";
import {redirectToSignInPage} from "../../utilities/redirectToSignInPage";
import NavigationMenu from "../NavigationMenu/navigationMenu";


const Header = () => {

    let location = useLocation()
    const {toggleOpenStatus, isOpen} = useFilterDataStore()
    const {token} = useUserStore();

    return (
        <div className={"header-area mb-4"}>
            <div className={"container-fluid header"} style={{background:`url(${headerBackgroundImage}) no-repeat`, backgroundSize:`100% 100%`}}>
                <div className={"container header__content"}>
                    <div className={"header__logo"}>
                        <img className={"header__logo-icon"} src={logo}/>
                        <Link to={'/'}><h1 className={"header__logo-text"}>Электронная библиотека</h1></Link>
                    </div>
                    <div className={"header__button"}>
                        {token ?
                            <UserMenu/>
                            :
                            <button className={"btn btn-outline-light"} onClick={redirectToSignInPage}>
                            <i className="bi bi-box-arrow-in-right me-2"></i>
                            <span>Войти</span>
                        </button>}
                        <div className={`header__search ${location.pathname.includes("advance-search") ? '' : 'd-none'}`}
                             onClick={()=>toggleOpenStatus()}>
                            {isOpen == false ?  <i className="bi bi-search"></i> : <i className="bi bi-x"></i>}
                        </div>
                    </div>
                </div>
            </div>
            { token && <NavigationMenu/>}
        </div>
    );
};

export default Header;